export default __webpack_public_path__ + "734e552f4b2a6401ae12c54eb84f2989.jpg";